export const DEFAULT_AUTH_HOST = 'https://auth.unionepro.ru';

export const DEFAULT_ONEID_HOST = 'https://oneid.unionepro.ru';

export const DEFAULT_COMMONS_API_HOST = 'https://commons.unionepro.ru';

export const BASE_IMAGE_URL = 'https://s3-api.unionepro.ru';

export const BASE_BUCKET = 'basebucket';

export const MESSENGER_LINK = 'https://messenger.unionepro.ru/'

export const ENV_PARTS = [
  'unionepro.ru',
  'unionetest.ru',
  'unionestage.ru',
  'unionedev.ru',
  'geocode.tech'
];

export const contactsItemsDefault = [
  {
    id: 'phone',
    translateKey: 'footer-phone',
    text: '+7\u00A0(800)\u00A0550\u00A031\u00A071',
    icon: 'PhoneIcon',
    href: 'tel:+78005503171'
  },
  {
    id: 'address',
    translateKey: 'footer-address',
    text: '420500, г. Иннополис, ул. Университетская, д.1',
    icon: 'LocationIcon',
    href: ''
  },
];

export const ENV_UNIONEDEV = 'unionedev.ru';

export enum Authorize {
  signedIn = 'signedIn',
  signedOut = 'signedOut',
  always = 'always',
}

export const doneSvg: string = 'https://s3-api.unionedev.ru/basebucket/done.svg'

export const mobileWidthSize = 1340
